import { initMenuMobile } from "./menuMobile";
import { initPostFilterTag } from "./postFilterTag";
import { initSliders } from "./sliders";
import { initTabs } from "./tabs-js";
import { initTeamModal } from "./teamModal";
document.addEventListener("DOMContentLoaded", function () {
  initMenuMobile();
  initSliders();
  initPostFilterTag();
  initTeamModal();
  initTabs();
});